import Api from "./axios";

export const getCatpcha = async (id) => {
  return await Api.get(`/user/generateCaptcha?captcha_id=${id ? id : ""}`);
};
